import type { AccountInfo } from "../../../../api/account";
import { PasswordCard } from "./PasswordCard";
import { SecondFactorCard } from "./SecondFactorCard";

/** My account → Authentication: the password first, then the second factor. */
export function AuthenticationSection({ account, onChanged }: { account: AccountInfo; onChanged: () => void }): React.JSX.Element {
  return (
    <>
      <PasswordCard email={account.email} onChanged={onChanged} />
      <SecondFactorCard account={account} onChanged={onChanged} />
    </>
  );
}
